// ----------------------------------------------------------------------
// <copyright file="Izenda.CopyManagementConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
//

import localizer from 'share/localization/Izenda.Localizer';

const REPORT_LIST_CONCAT_TREE_MAP = [
  {
    prop: 'subCategories',
    showTotal: false,
    defaultName: 'UNSUBCATEGORIZED',
    children: [
      {
        prop: 'reports',
        showTotal: false
      }
    ]
  }
];

const DATE_MODEL_CONCAT_TREE_MAP = [
  {
    prop: 'querySources',
    showTotal: true,
    children: [
      {
        prop: 'Tables',
        showTotal: true,
        disabledIfNoChild: true,
        children: [
          {
            prop: 'items',
            showTotal: false
          }
        ]
      },
      {
        prop: 'Functions',
        showTotal: true,
        disabledIfNoChild: true,
        children: [
          {
            prop: 'items',
            showTotal: false
          }
        ]
      },
      {
        prop: 'Views',
        showTotal: true,
        disabledIfNoChild: true,
        children: [
          {
            prop: 'items',
            showTotal: false
          }
        ]
      },
      {
        prop: 'StoredProcedures',
        showTotal: true,
        disabledIfNoChild: true,
        children: [
          {
            prop: 'items',
            showTotal: false
          }
        ]
      }
    ]
  }
];

export default {
  get DEFAULT_WORKSPACE_NAME() {
    return localizer.getText('COPY_MANAGEMENT_LABEL_DEFAULT_WORKSPACE_NAME');
  },
  WORKSPACE_NAME: 'workspaceName',
  get UNKNOWN_STATUS() {
    return localizer.getText('COPY_MANAGEMENT_LABEL_UNKNOWN_STATUS');
  },
  WORKSPACE_NAME_MAX_LENGTH: 150,

  get WORKSPACE_NAME_CONSTRAINT() {
    return {
      presence: {
        presence: true,
        message: localizer.getText('COPY_MANAGEMENT_MESSAGE_WORKSPACE_NAME_CONSTRAINT_PRESENCE')
      },
      length: {
        maximum: 150,
        message: localizer.getText('COPY_MANAGEMENT_MESSAGE_WORKSPACE_NAME_CONSTRAINT_LENGTH')
      }
    };
  },
  get DESTINATION_CONSTRAINTS() {
    return {
      presence: {
        presence: true,
        message: localizer.getText('COPY_MANAGEMENT_MESSAGE_DESTINATION_CONSTRAINT')
      }
    };
  },
  get systemSource() {
    return {
      id: '00000000-0000-0000-0000-000000000000',
      name: localizer.getText('COMMON_LABEL_SYSTEM')
    };
  },
  get M01() {
    return localizer.getText('COPY_MANAGEMENT_MESSAGE_CONFIRM_DELETE_WORKSPACE');
  },
  get M11() {
    return localizer.getText('COPY_MANAGEMENT_MESSAGE_CONFIRM_DELETE_TENANT');
  },
  get TABLE_DESTINATION_DEFINITION() {
    return {
      tenantName: {
        key: 'tenantName',
        columnKey: 'tenantName',
        width: 80,
        title: localizer.getText('COMMON_LABEL_TENANT'),
        sortable: true
      },
      status: {
        key: 'status',
        columnKey: 'status',
        width: 80,
        title: localizer.getText('COMMON_LABEL_STATUS'),
        sortable: true
      },
      action: {
        key: 'status',
        columnKey: 'action',
        width: 100,
        align: 'center',
        title: localizer.getText('COMMON_LABEL_ACTION'),
        sortable: false,
        fixed: true
      }
    };
  },
  get STATUS_OF_DESTINATION() {
    return {
      '0': {
        status: localizer.getText('COPY_MANAGEMENT_MESSAGE_STATUS_DEST_NEED_VALIDATION'),
        class: 'need-validated',
        iconClass: '',
        iconOkClass: ''
      },
      '1': {
        status: localizer.getText('COPY_MANAGEMENT_MESSAGE_STATUS_DEST_READY_TO_COPY'),
        class: 'ready-to-copy',
        iconClass: '',
        iconOkClass: 'ready-to-copy'
      },
      '2': {
        status: localizer.getText('COPY_MANAGEMENT_MESSAGE_STATUS_DEST_MISSING_AUTHEN'),
        class: 'authentication-missing',
        iconClass: 'icon-info-circled',
        iconOkClass: 'ready-to-copy'
      },
      '3': {
        status: localizer.getText('COPY_MANAGEMENT_MESSAGE_STATUS_DEST_VALIDATION_ERROR'),
        class: 'validation-error',
        iconClass: 'icon-info-circled',
        iconOkClass: 'icon-disabled'
      },
      NEED_VALIDATION: 0,
      READY_TO_COPY: 1,
      AUTHENTICATION_MISSION: 2,
      VALIDATION_ERROR: 3
    };
  },
  get VALIDATION_ERROR_TOOLTIP() {
    return localizer.getText('COPY_MANAGEMENT_VALIDATION_ERROR_TOOLTIP');
  },
  get COPY_MANAGEMENT_OBJECT_TOOLTIP() {
    return localizer.getText('COPY_MANAGEMENT_OBJECT_TOOLTIP');
  },
  get SAVE_WORKSPACE_CONSTRAINTS() {
    return {
      NAME: {
        presence: {
          presence: true,
          message: localizer.getText('COPY_MANAGEMENT_MESSAGE_SAVE_WORKSPACE_CONSTRAINTS_NAME')
        }
      },
      OWNER: {
        presence: {
          presence: true,
          message: localizer.getText('COPY_MANAGEMENT_MESSAGE_SAVE_WORKSPACE_CONSTRAINTS_OWNER')
        }
      },
      WORKSPACE_NAME: {
        presence: {
          presence: true,
          message: localizer.getText('COPY_MANAGEMENT_MESSAGE_SAVE_WORKSPACE_CONSTRAINTS_WORKSPACE_NAME')
        }
      }
    };
  },
  get TABLE_DEF() {
    return {
      GLOBAL_MAPPING: {
        fromDatabaseName: {
          key: 'fromDatabaseName',
          columnKey: 'fromDatabaseName',
          width: 170,
          title: localizer.getText('COPY_MANAGEMENT_LABEL_TABLE_DEF_GLOBAL_MAPPING_FROM_DB_NAME')
        },
        type: { key: 'type', columnKey: 'type', width: 150, title: localizer.getText('COMMON_LABEL_TYPE') },
        fromObject: {
          key: 'fromObject',
          columnKey: 'fromObject',
          width: 150,
          title: localizer.getText('COMMON_LABEL_OBJECT')
        },
        toDatabaseName: {
          key: 'toDatabaseName',
          columnKey: 'toDatabaseName',
          width: 150,
          title: localizer.getText('COPY_MANAGEMENT_LABEL_TABLE_DEF_GLOBAL_MAPPING_TO_DB_NAME')
        },
        toObject: {
          key: 'toObject',
          columnKey: 'toObject',
          width: 150,
          title: localizer.getText('COMMON_LABEL_OBJECT'),
          infoIconOptions: {
            iconClass: 'icon-info-circled',
            iconTitle: localizer.getText('COPY_MANAGEMENT_OBJECT_TOOLTIP')
          }
        },
        tenant: {
          key: 'workspaceMappingTenants',
          columnKey: 'workspaceMappingTenants',
          width: 200,
          title: localizer.getText('COMMON_LABEL_TENANT')
        },
        action: {
          width: 70,
          fixed: true,
          align: 'center',
          title: localizer.getText('COMMON_LABEL_ACTION'),
          className: 'align-bottom'
        }
      },
      TENANT_MAPPING: {
        fromDatabaseName: {
          key: 'fromDatabaseName',
          columnKey: 'fromDatabaseName',
          width: 170,
          title: localizer.getText('COMMON_LABEL_DATA_SOURCE')
        },
        type: { key: 'type', columnKey: 'type', width: 150, title: localizer.getText('COMMON_LABEL_TYPE') },
        fromObject: {
          key: 'fromObject',
          columnKey: 'fromObject',
          width: 150,
          title: localizer.getText('COMMON_LABEL_OBJECT')
        },
        toDatabaseName: {
          key: 'toDatabaseName',
          columnKey: 'toDatabaseName',
          width: 150,
          title: localizer.getText('COMMON_LABEL_DATA_SOURCE')
        },
        toObject: {
          key: 'toObject',
          columnKey: 'toObject',
          width: 150,
          title: localizer.getText('COMMON_LABEL_OBJECT'),
          infoIconOptions: {
            iconClass: 'icon-info-circled',
            iconTitle: localizer.getText('COPY_MANAGEMENT_OBJECT_TOOLTIP')
          }
        },
        action: {
          width: 70,
          fixed: true,
          align: 'center',
          title: localizer.getText('COMMON_LABEL_ACTION'),
          className: 'align-bottom'
        }
      }
    };
  },
  DESTINATION_SORT_DIR: {
    version: 'DESC'
  },
  get MAPPING_HEADER() {
    return {
      GLOBAL: localizer.getText('COPY_MANAGEMENT_LABEL_MAPPING_HEADER_GLOBAL'),
      TENANT: localizer.getText('COPY_MANAGEMENT_LABEL_MAPPING_HEADER_TENANT'),
      ALL_MAPPING_TOOLTIP: localizer.getText('COPY_MANAGEMENT_ALL_MAPPING_TOOLTIP'),
      MERGE_DUPLICATE_TOOLTIP: localizer.getText('COPY_MANAGEMENT_MERGE_DUPLICATE_TOOLTIP'),
      SPECIFIC_MAPPING_TOOLTIP: localizer.getText('COPY_MANAGEMENT_SPECIFIC_MAPPING_TOOLTIP')
    };
  },
  get REQUIRE_CONSTRAINT() {
    return {
      presence: {
        presence: true,
        message: localizer.getText('COMMON_CONSTRAINT_REQUIRED')
      }
    };
  },
  get MAPPING_TYPES() {
    return [
      { label: localizer.getText('COPY_MANAGEMENT_LABEL_MAPPING_TYPE_SCHEMA'), value: 1 },
      { label: localizer.getText('COPY_MANAGEMENT_LABEL_MAPPING_TYPE_DATABASE'), value: 2 }
    ];
  },
  MAPPING_TYPE: {
    Schema: 1,
    Database: 2
  },

  DETECTED_CHANGE_LEVEL: {
    NONE: 0,
    ADDED: 1,
    MODIFIED: 2
  },
  get CONSISTENT_DATA_MODEL() {
    return localizer.getText('COPY_MANAGEMENT_MESSAGE_CONSISTENT_DATA_MODEL');
  },
  get INCONSISTENT_DATA_MODEL() {
    return localizer.getText('COPY_MANAGEMENT_MESSAGE_INCONSISTENT_DATA_MODEL');
  },
  get CHANGED_DATA_TYPE() {
    return localizer.getText('COPY_MANAGEMENT_MESSAGE_CHANGED_DATA_TYPE');
  },
  get DELETED_DATA_SOURCE() {
    return localizer.getText('COPY_MANAGEMENT_MESSAGE_DELETED_DATA_SOURCE');
  },

  APPROVAL_LEVEL: {
    PENDING: 0,
    QUERY_SOURCE: 1,
    QUERY_SOURCE_FIELD: 2
  },
  TENANT_TOKEN: '@TenantID',
  TENANT_NAME_TOKEN: '@TenantName',
  get OVERRIDE_CONFIRMATION() {
    return {
      MG01: localizer.getText('COPY_MANAGEMENT_MESSAGE_OVERRIDE_CONFIRMATION_HAVING_SETUP'),
      MG02: localizer.getText('COPY_MANAGEMENT_MESSAGE_OVERRIDE_CONFIRMATION_SELECT_TO_OVERWRITTEN')
    };
  },
  DATETIME_FORMAT: 'MM/dd/yyyy HH:mm:ss tt',
  get RUN_COPY_SUCCESS() {
    return localizer.getText('COPY_MANAGEMENT_MESSAGE_COPY_PROCESS_DONE');
  },
  get COPY_FILTER_LOOKUP_MESSAGE() {
    return localizer.getText('COPY_MANAGEMENT_MESSAGE_COPY_FILTER_LOOKUP');
  },
  CONCURRENCY_ERROR: {
    SOURCE: 1,
    DESTINATION: 2
  },
  MODULE_ANCHORS: {
    DATA_MODEL_SETTING: 'DataModelSetting',
    ROLE_SETTING: 'RoleSetting',
    ROLE_PERMISSION_SETTING: 'RolePermissionSetting'
  },
  NODE_TYPE: {
    STORE_PROCEDURE: 'Stored Procedure',
    FUNCTION: 'Function',
    TABLE: 'Table',
    VIEW: 'View'
  },
  REPORT_LIST_CONCAT_TREE_MAP,
  REPORT_LIST_TREE_MAP: [
    {
      prop: 'all',
      showTotal: false,
      children: [
        {
          prop: 'categories',
          showTotal: false,
          defaultName: 'UNCATEGORIZED',
          children: REPORT_LIST_CONCAT_TREE_MAP
        }
      ]
    }
  ],
  DATE_MODEL_CONCAT_TREE_MAP,
  DATE_MODEL_TREE_MAP: [
    {
      prop: 'connections',
      showTotal: false,
      children: DATE_MODEL_CONCAT_TREE_MAP
    }
  ],
  SOURCE_TYPE_DEFINITIONS: [
    {
      CollectionKey: 'Tables',
      Key: 'Table',
      totalChildrenKey: 'totalTableChildNodes',
      numOfCheckedChildren: 'totalTableCheckedNodes'
    },
    {
      CollectionKey: 'Views',
      Key: 'View',
      totalChildrenKey: 'totalViewChildNodes',
      numOfCheckedChildren: 'totalViewCheckedNodes'
    },
    {
      CollectionKey: 'StoredProcedures',
      Key: 'Stored Procedure',
      totalChildrenKey: 'totalStoredProcedureChildNodes',
      numOfCheckedChildren: 'totalStoredProcedureCheckedNodes'
    },
    {
      CollectionKey: 'Functions',
      Key: 'Function',
      totalChildrenKey: 'totalFunctionChildNodes',
      numOfCheckedChildren: 'totalFunctionCheckedNodes'
    }
  ]
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.CopyManagementConstants.js